export const en = {
  common: {
    cancel: 'Cancel',
    save: 'Save',
    done: 'Done',
    saving: 'Saving…',
    loading: 'Loading…',
    error: 'Error',
    close: 'Close',
    back: 'Back',
    search: 'Search…',
    english: 'English',
    arabic: 'Arabic',
    language: 'Language',
    comment: 'Comment',
    everyone: 'Everyone',
    student_one: '{{count}} student',
    student_other: '{{count}} students',
    allMembers: 'All members',
    selectMembers: 'Select members',
    selected_one: '{{count}} selected',
    selected_other: '{{count}} selected',
    recipient_one: '{{count}} recipient',
    recipient_other: '{{count}} recipients',
    managementFootnote: 'Staff and teacher members of this class will still receive this post.',
    noIndividualRecipients:
      'Individual recipients are not available for this class — the post will be sent to all members.',
    selectAtLeastOne: 'Please select at least one student or choose All members.',
    you: 'You',
    backToHome: 'Back to Home',
    saveChanges: 'Save changes',
    confirmDelete: 'Confirm delete',
    optional: 'Optional',
    today: 'Today',
    yesterday: 'Yesterday',
    previous: 'Previous',
    next: 'Next',
    selectDate: 'Select date',
    datePickerAria: 'Date picker',
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    previousYears: 'Previous years',
    nextYears: 'Next years',
    selectMonth: 'Select month',
    selectYear: 'Select year',
    monthJanuary: 'January',
    monthFebruary: 'February',
    monthMarch: 'March',
    monthApril: 'April',
    monthMay: 'May',
    monthJune: 'June',
    monthJuly: 'July',
    monthAugust: 'August',
    monthSeptember: 'September',
    monthOctober: 'October',
    monthNovember: 'November',
    monthDecember: 'December',
    weekdaySu: 'Su',
    weekdayMo: 'Mo',
    weekdayTu: 'Tu',
    weekdayWe: 'We',
    weekdayTh: 'Th',
    weekdayFr: 'Fr',
    weekdaySa: 'Sa',
    selectTime: 'Select time',
    timePickerAria: 'Time picker',
    hour: 'Hour',
    minute: 'Minute',
    amPm: 'AM/PM',
    now: 'Now',
    timePlaceholder: '—:—',
    select: 'Select…',
    optionsAria: 'Options',
    noMatchesGeneric: 'No matches',
    somethingWentWrong: 'Something went wrong',
    closeDialogAria: 'Close dialog',
    errorCode: 'Code: {{code}}',
    ok: 'OK',
    closeMenu: 'Close menu',
    download: 'Download',
    reply: 'Reply',
    linkCopied: 'Link copied',
    noSubject: 'No subject',
    notFoundDescription: 'The page you are looking for does not exist.',
    goHome: 'Go Home',
    premiumMember: 'Premium member',
    verified: 'Verified',
    premiumAccount: 'Premium account',
    verifiedAccount: 'Verified account',
  },
  nav: {
    home: 'Home',
    explore: 'Explore',
    messages: 'Messages',
    calendar: 'Calendar',
    payments: 'Payments',
    reportCards: 'Report Cards',
    ownedClasses: 'Owned Classes',
    joinedClasses: 'Joined Classes',
    addClass: 'Add class',
    noOwnedClasses: 'You don’t own any classes yet.',
    noJoinedClasses: 'You haven’t joined any classes yet.',
    tryPrime: 'Try MyU Prime',
    mainNav: 'Main',
    openMenu: 'Open navigation menu',
    closeMenu: 'Close navigation menu',
  },
  userMenu: {
    viewProfile: 'View profile',
    shareProfile: 'Share profile',
    settings: 'Settings',
    logout: 'Logout',
  },
  auth: {
    signIn: 'Sign In',
    signInSubtitle: 'Welcome back! Please enter your details',
    emailOrUsername: 'Email or username',
    emailPlaceholder: 'Email or username',
    password: 'Password',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    passwordPlaceholder: 'Enter your password',
    forgotPassword: 'Forgot password?',
    noAccount: "Don't have an account?",
    createAccount: 'Create Account',
    register: 'Register',
    signingIn: 'Signing in…',
    verificationLinkNote: 'A verification link will be sent',
    registerTitle: 'Create your account',
    forgotTitle: 'Forgot password?',
    forgotSubtitle: 'Enter your username or email and we will send reset instructions.',
    send: 'Send',
    sending: 'Sending…',
    forgotSuccess: 'Please check your email for password reset instructions.',
    alreadyHaveAccount: 'Already have an account?',
    logIn: 'Log in',
    continue: 'Continue',
    closeRegistration: 'Close registration',
    selectAccountType: 'Select Your Account Type',
    chooseAccountTypeSubtitle: 'Choose the option that best describes you',
    accountTypeStudent: 'Student',
    accountTypeInstructor: 'Teacher or Professor',
    accountTypeManagement: 'Staff',
    accountTypeParent: 'Parent',
    managementControlPanelCta: 'Registering your school for the Management control panel?',
    managementControlPanelLink: 'Go to Management registration',
    findSchool: 'Find Your School',
    findUniversity: 'Find Your University',
    schoolPlaceholder: 'Type your school name...',
    universityPlaceholder: 'Type your university name...',
    findInstitutionSubtitle: 'Search and select your institution to get started',
    educationalInstitution: 'Educational Institution',
    noMatches: 'No matches found for "{{query}}".',
    suggestionsFailed: 'Failed to load suggestions. Please try again.',
    keepTyping: 'Keep typing to see suggestions…',
    createProfile: 'Create Your Profile',
    createProfileSubtitle: 'Tell us about yourself to complete your registration',
    firstName: 'First and Middle Name',
    lastName: 'Last Name',
    username: 'Username',
    emailAddress: 'Email Address',
    firstNamePlaceholder: 'John',
    lastNamePlaceholder: 'Doe',
    firstNameInvalid: 'Please enter a valid name with at least one letter.',
    lastNameInvalid: 'Please enter a valid name with at least one letter.',
    usernamePlaceholder: 'johndoe',
    usernameChecking: 'Checking availability…',
    usernameAvailable: 'Username is available',
    usernameTaken: 'This username is already taken.',
    usernameInvalidFormat: 'Use 3–30 letters, numbers, or underscores.',
    usernameSuggestionsLabel: 'Try one of these:',
    emailPlaceholderRegister: 'john.doe@university.edu',
    emailChecking: 'Checking email…',
    emailTaken: 'This email is already registered.',
    emailInvalidFormat: 'Please enter a valid email address.',
    verificationEmailNote: 'A verification link will be sent to your email',
    createStrongPassword: 'Create a strong password',
    creatingAccount: 'Creating account…',
    agreeTermsPrefix: 'By registering you agree to our',
    termsOfService: 'terms of service',
    and: 'and',
    privacyPolicy: 'privacy policy',
    goBack: 'Go back',
    pushGateHint: 'Enable notifications above to continue.',
    usernameOrEmail: 'Username or Email',
    forgotEmailPlaceholder: 'your.email@university.edu',
    resetLinkNote: 'A password reset link will be sent to the email associated with your account.',
    sendResetLink: 'Send Reset Link',
    backToSignIn: 'Back to Sign In',
    forgotValidationRequired: 'Please enter your username or email address.',
    registerCompleteTitle: "You're all set!",
    verificationSentTo: 'Verification link sent to',
    yourEmailAddress: 'your email address',
    verifyEmailPrompt: 'Click the verification link in that email to confirm your account.',
    starting: 'Starting…',
    start: 'Start',
    pickInstitutionBeforeContinue:
      'Please pick an institution from the suggestions before continuing.',
  },
  settings: {
    title: 'Settings',
    description: 'Manage your account, privacy, and app preferences.',
    archivedClasses: 'Archived classes',
    blockedUsers: 'Blocked users',
    storageTitle: 'Storage space',
    storageDescription: 'Documents and videos stored on MyU count toward your limit.',
    storageUsed: '{{used}} of {{limit}} used',
    storageAria: 'Storage used',
    network: 'Network',
    connected: 'Connected',
    connecting: 'Connecting…',
    offline: 'Offline',
    prime: 'MyU Prime',
    primeActive: 'Active until {{date}}',
    primeInactive: 'Upgrade for more storage and features',
    about: 'About',
    version: 'Version',
    contact: 'Contact us',
    privacy: 'Privacy & visibility',
    notifications: 'Notifications',
    account: 'Account',
    pushNotifications: 'Push notifications',
    pushNotificationsDescription: 'Choose which activity sends push alerts.',
    privacyDescription: 'Control who can see and interact with you.',
    accountLegal: 'Account & legal',
    accountLegalDescription: 'About MyU, policies, and account actions.',
    contactUs: 'Contact us',
    networkStatus: 'Network status',
    active: 'Active',
    activeUntil: 'Active until {{date}}',
    viewPrime: 'View MyU Prime',
    upgradePrime: 'Upgrade to MyU Prime',
    upgradePrimeDescription: 'Upgrade for {{gb}} GB storage, priority support, and more.',
    backToSettings: 'Back to settings',
    privacyPageDescription: 'Control your account privacy and how others can interact with you.',
    privacyIntro:
      'These settings apply across MyU. You can still change options for individual posts when you publish.',
    privateAccount: 'Private account',
    privateAccountDescription:
      'When your account is private, you must approve follow requests before anyone can see your posts.',
    showOnExplore: 'Show on explore page',
    showOnExploreDescription:
      'When enabled, your profile may appear on the explore page. Ranking is based on engagement with your account.',
    receiveComments: 'Receive comments',
    receiveCommentsDescription:
      'Default for new posts. You can still allow or block comments on each post after publishing.',
    allowDownloads: 'Allow downloads',
    allowDownloadsDescription:
      'Control whether other users can download your uploaded photos, videos, and files.',
    messageFromLegend: 'Receive private messages from',
    messageFromAnyone: 'Anyone on MyU',
    messageFromSchoolAndConnections:
      'Within my institution, and accounts I follow or share a class with',
    messageFromConnectionsOnly: 'Only accounts I follow or share a class with',
    messageFromNoOne: 'No one',
    pushNotificationsPageDescription: 'Choose which notifications are sent to your devices.',
    pushNewPosts: 'New posts',
    pushNewPostsDescription: 'When someone you follow publishes a new post.',
    pushLikes: 'Likes',
    pushLikesDescription: 'When someone likes your post or comment.',
    pushComments: 'Comments',
    pushCommentsDescription: 'When someone comments on your posts.',
    pushMessages: 'Messages',
    pushMessagesDescription: 'New direct messages and group chat activity.',
    pushFollowing: 'Following',
    pushFollowingDescription: 'When someone follows you or accepts your request.',
    pushClassJoins: 'Class joins',
    pushClassJoinsDescription: 'When members join classes you manage.',
    accountLegalPageDescription: 'Learn about MyU and manage your account status.',
    aboutUs: 'About us',
    privacyPolicyLink: 'Privacy policy',
    accountActions: 'Account actions',
    disableAccount: 'Disable account',
    disableAccountDescription:
      'Temporarily hide your profile and pause notifications. You can sign back in anytime to reactivate.',
    enableAccount: 'Enable account',
    enableAccountDescription: 'Reactivate your profile and resume normal account access.',
    deleteAccount: 'Delete account',
    deleteAccountDescription:
      'Delete your account from MyU. You will be signed out after the request succeeds.',
    disableAccountConfirm: 'Disable account?',
    enableAccountConfirm: 'Enable account?',
    deleteAccountConfirm: 'Delete account?',
    disableAccountDemoNote:
      'Your profile will be hidden until your account is reactivated. You will be signed out after disabling it.',
    enableAccountDemoNote: 'Your profile and account access will be restored.',
    deleteAccountDemoNote:
      'Your account deletion request will be sent now. You will be signed out after it succeeds.',
    accountActionFailed: 'Could not update your account. Please try again.',
    accountActionSignInRequired: 'Please sign in again before changing your account status.',
    disable: 'Disable',
    enable: 'Enable',
    deletePermanently: 'Delete account',
    blockedUsersDescription: 'Blocked users cannot message you, follow you, or see your profile.',
    blockedUsersLoadError: 'Couldn’t load blocked users',
    connectionError: 'Please check your connection and try again.',
    noBlockedUsers: 'No blocked users',
    noBlockedUsersDescription:
      'When you block someone, they will appear here and you can unblock them at any time.',
    unblock: 'Unblock',
    archivedClassesDescription: 'Tap a class to open it, or use Edit to restore or update details.',
    archivedClassesLoadError: 'Couldn’t load archived classes',
    noArchivedClasses: 'No archived classes',
    noArchivedClassesDescription:
      'When you archive a class, it will appear here. Open a class to view it, or edit it to restore or make changes.',
  },
  post: {
    editCaption: 'Edit caption',
    editRecipients: 'Edit recipients',
    disableComments: 'Disable comments',
    enableComments: 'Enable comments',
    pinToClass: 'Pin to class',
    pinToProfile: 'Pin to profile',
    unpinFromClass: 'Unpin from class',
    unpinFromProfile: 'Unpin from profile',
    deletePost: 'Delete post',
    postOptions: 'Post options',
    editRecipientsTitle: 'Edit recipients',
    editRecipientsIntro: 'Choose who receives this post in {{className}}.',
    loadingRoster: 'Loading roster…',
    recipientsLabel: 'Recipients: {{label}}',
    likesAria_one: '1 like. View who liked',
    likesAria_other: '{{count}} likes. View who liked',
    commentsAria: '{{count}} comments. View comments',
    commentsDisabledAria: '{{count}} comments. View comments (new comments disabled)',
    impressionsAria_one: '1 impression. View post insights',
    impressionsAria_other: '{{count}} impressions. View post insights',
    impressionsReadOnly: '{{count}} impressions',
    inClass: 'In {{className}}',
    pinned: 'Pinned',
    promoted: 'Promoted',
    newCommentsDisabled: 'New comments are disabled',
    detailModalAriaLabel: 'Post and comments',
    detailModalTitle: 'Post',
    commentCount_one: '{{count}} comment',
    commentCount_other: '{{count}} comments',
    commentsDisabledWithExisting: 'New comments are disabled on this post.',
    commentsDisabledEmpty: 'Comments are disabled on this post.',
    editCaptionPlaceholder: 'Write a caption… Use #hashtags or @mentions',
    pinnedToClass: 'Pinned to {{className}}',
    pinnedToProfile: 'Pinned to profile',
    questionBannerLabel: 'Question',
    questionGradedLine: 'Graded · {{termName}} · {{categoryName}} · {{totalGrade}} pts',
    extendDueDate: 'Extend due date',
    extendDueDateDescription:
      'Updates the due date for all copies of this question sent in the same batch.',
    newDueDate: 'New due date',
    newDueTime: 'New due time',
    questionOptionsAria: 'Question options',
    dueOn: 'Due on',
    editBeforeDueFootnote: 'Recipients may edit their responses before the due date.',
    submitError: 'Failed to submit response. Please try again.',
    submitAlreadyGradedError:
      'Your response has already been graded. View your response to see your grade.',
    reviewResponses: 'Review responses',
    reviewResponsesCount: 'Review responses ({{count}})',
    viewYourResponse: 'View your response',
    responseRejectedCtaHint: 'Response rejected - view details',
    responseSubmittedGradeCtaHint: 'Response submitted - Grade: {{score}}/{{max}}',
    responsesClosed: 'Responses closed',
    submitResponse: 'Submit response',
    yourResponse: 'Your response',
    saveChanges: 'Save changes',
    respondingTo: 'Responding to {{title}}',
    responsePlaceholder:
      'Write your private response. Long answers and essays can expand as you type…',
    submitting: 'Submitting…',
    dueStatusOpen: 'Open',
    dueStatusClosingSoon: 'Closing soon',
    dueStatusClosed: 'Closed',
    eventBannerLabel: 'Event',
    eventAriaLabel: 'Event: {{title}}',
    eventWhen: 'When',
    eventStarts: 'Starts',
    eventEnds: 'Ends',
    eventOver: 'This event is over',
    attendanceNoConfirmationsOwn: 'No one confirmed yet',
    attendanceConfirm: 'Confirm attendance',
    attendanceOneConfirmedOwn: '1 person confirmed',
    attendanceYouConfirmed: 'You confirmed',
    attendanceCountConfirmedOwn: '{{count}} people confirmed',
    attendanceYouAndOthers: 'You and {{count}} others confirmed',
    attendanceModalAria: 'Event attendance',
    attendanceModalTitle: 'Confirmed attendance',
    attendanceLoading: 'Loading confirmed attendees…',
    attendanceErrorTitle: 'Could not load attendees',
    attendanceErrorDescription: 'Please close this window and try again.',
    attendanceEmptyTitle: 'No confirmations yet',
    attendanceEmptyDescription: 'When people confirm, they will appear here.',
    googleMeetSectionAria: 'Google Meet',
    googleMeetReady: 'Google Meet is ready',
    googleMeetCopyLink: 'Copy meeting link',
    googleMeetLinkCopied: 'Link copied',
    googleMeetJoin: 'Join with Google Meet',
    googleMeetCopiedStatus: 'Link copied to clipboard',
    googleSignInButton: 'Sign in with Google',
    googleSigningIn: 'Signing in…',
    googleSignInPreviewSignedOut: 'Preview signed-out state',

    // Report post
    reportPost: 'Report',
    reportModalTitle: 'Report',
    reportModalAria: 'Report post',
    reportOptionSpam: "It's spam",
    reportOptionInappropriate: "It's inappropriate",
    reportOptionHarmful: "It's disrespectful or harmful",
    reportOptionOther: 'Other reason',
    reportOtherPlaceholder: 'Please describe the issue…',
    reportSubmit: 'Submit',
    reportSubmittedTitle: 'Thanks for letting us know',
    reportSubmittedBody: 'Your report has been submitted. We will review it shortly.',
    reportDone: 'Done',
    reportError: 'Failed to submit report. Please try again.',

    googleSignInPreviewSignedIn: 'Preview signed-in state',
    likesTitle: 'Likes',
    likesTitle_one: '1 like',
    likesTitle_other: '{{count}} likes',
    likesLoading: 'Loading likes…',
    likesErrorTitle: "Couldn't load likes",
    likesErrorDescription: 'Please try again in a moment.',
    likesEmptyTitle: 'No likes yet',
    likesEmptyDescription: 'When someone likes this post, they will show up here.',
    insightsTitle: 'Post insights',
    insightsSummaryAria: 'Post analytics summary',
    insightsTotalImpressions: 'Total impressions',
    insightsTotalImpressionsHint: 'Every view counts',
    insightsViewers: 'Viewers',
    insightsViewersHint: 'Each user counts once',
    insightsLoadAnalyticsError: 'Could not load analytics.',
    insightsEngagementHeading: 'Engagement',
    insightsLikes: 'Likes',
    insightsComments: 'Comments',
    insightsClicks: 'Clicks',
    insightsMediaViews: 'Media views',
    insightsViewersByImpressionsHeading: 'Viewers by impressions',
    insightsViewersByImpressionsHint: 'Impressions per viewer; counts above 10 show as 10+.',
    insightsViewersTotal: '{{count}} total',
    insightsNoViewersTitle: 'No viewers yet',
    insightsNoViewersDescription:
      'When people view this post, they will appear here with their impression counts.',
    insightsLoadViewersErrorTitle: 'Could not load viewers',
    insightsTryAgainDescription: 'Please try again in a moment.',
    insightsViewerImpressionsAria: '{{count}} impressions from this viewer',
    insightsLoadMoreViewers: 'Load more viewers',
    insightsAnonymousUser: 'MyU user',
    responsePrivateLabel: 'Private response',
    responseRejectedBanner: 'This response was rejected.',
    responseYourReview: 'Your review',
    responseGradeLabel: 'Grade',
    responseGradeOutOf: '(out of {{max}} pts)',
    responseGradePlaceholder: 'Enter score',
    responseGradeInvalid: 'Enter a valid grade.',
    responseGradeBelowZero: 'Grade cannot be less than 0.',
    responseGradeAboveMax: 'Grade cannot be more than {{max}} points.',
    responseSaveGrade: 'Save grade',
    responseGradeSaved: 'Saved · {{score}} / {{max}}',
    responseGradeDisplay: '{{score}} / {{max}} pts',
    responseYourGrade: 'Your grade',
    responseGradeReceivedNote: 'You received a grade for this response.',
    responseRejectedLabel: 'Response Rejected',
    responseRejectedMessage:
      'This response was rejected. You can submit a new response or make revisions and submit again.',
    responseSubmitAgain: 'Submit Again',
    responseHideFeedback: 'Hide feedback',
    responseViewFeedback: 'View feedback ({{count}})',
    responseGiveFeedback: 'Give feedback',
    responseReject: 'Reject',
    responseNoFeedbackYet: 'No feedback yet. Add a note for this recipient below.',
    responseFeedbackPlaceholder: 'Write feedback for this recipient…',
    responsePostFeedback: 'Post feedback',
    responseFeedbackFromOwner: 'Feedback from question owner',
    responseTeacherFallback: 'Teacher',
    loadingResponse: 'Loading your response…',
    loadingFeedback: 'Loading feedback…',
    noResponseContent: 'No text content submitted.',
    noFeedbackYet: 'No feedback from the question owner yet.',
    questionOwner: 'Question owner',
    editResponse: 'Edit response',
    commentReplyingTo: 'Replying to @{{username}}',
    commentCancelReply: 'Cancel reply',
    commentPlaceholder: 'Write a comment…',
    commentReply: 'Reply',
    commentViewMoreReplies_one: 'View {{count}} more reply',
    commentViewMoreReplies_other: 'View {{count}} more replies',
    commentHideReplies: 'Hide replies',
    commentOptionsAria: 'Comment options',
    commentDelete: 'Delete',
    commentDeleting: 'Deleting…',
    commentViewImageAria: 'View {{name}}',
    playVideo: 'Play video',
    videoThumbnailAlt: 'Video thumbnail',
    galleryOpenImage: 'Open image',
    galleryViewAllImagesMore: 'View all images, {{count}} more',
    galleryMoreOverlay: '+{{count}} More',
    galleryAriaLabel: 'Image gallery',
    galleryImageAlt: 'Image {{index}} of {{total}}',
    galleryPrevious: 'Previous image',
    galleryNext: 'Next image',
    galleryDownload: 'Download',
    galleryClose: 'Close gallery',
    galleryViewImage: 'View image {{index}}',
    documentPreviewAria: 'Preview {{name}}',
    documentPreviewIframeTitle: 'Preview of {{name}}',
    documentCantSeePreview: "Can't see the preview?",
    documentDownloadTheFile: 'Download the file',
    documentNoBrowserPreview:
      'Preview is not available in the browser. Download the file to open it.',
    documentNoPreviewUrl: 'No preview URL is available for this file.',
    documentDownloadFile: 'Download file',
    documentTypePdf: 'PDF document',
    documentTypeWord: 'Word document',
    documentTypePpt: 'PowerPoint presentation',
    documentTypeExcel: 'Excel spreadsheet',
    videoPreviewAria: 'Video preview',
    videoTitle: 'Video',
  },
  messages: {
    title: 'Messages',
    historyError: 'Could not load chat history: {{error}}',
    fetchingNew: 'Fetching new messages…',
    fetchingInitial: 'Fetching your messages…',
    unreadMessages: 'Unread messages',
    searchConversations: 'Search conversations…',
    searchArchived: 'Search archived…',
    noArchivedChats: 'No archived chats',
    noConversationsFound: 'No conversations found',
    archiveHint: 'Archive a chat from its header or the conversation menu to find it here.',
    searchHint: 'Try a different search or start a new conversation.',
    chats: 'Chats',
    archived: 'Archived',
    emptyTitle: 'Your messages',
    emptyDescription:
      'Select a conversation or start a new chat with someone you follow or share a class with.',
    newConversation: 'New conversation',
    newChat: '+ New',
    startConversationAria: 'Start a new conversation',
    typing: 'typing…',
    member_one: '{{count}} member',
    member_other: '{{count}} members',
    group: 'Group',
    online: 'Online',
    offline: 'Offline',
    backToConversations: 'Back to conversations',
    searchInConversation: 'Search in conversation',
    pinConversation: 'Pin conversation',
    unpinConversation: 'Unpin conversation',
    archiveConversation: 'Archive conversation',
    unarchiveConversation: 'Unarchive conversation',
    viewContactInfo: 'View contact info',
    viewGroupInfo: 'View group info',
    pinned: 'Pinned',
    pin: 'Pin',
    unpin: 'Unpin',
    moveToChats: 'Move to Chats',
    archive: 'Archive',
    conversationOptions: 'Conversation options',
    typeMessage: 'Type a message...',
    composerKeyboardHint:
      'Press Enter to send. Shift+Enter or Option+Enter for a new line. Escape cancels reply.',
    unblock: 'Unblock',
    recording: 'Recording…',
    attachFile: 'Attach file',
    attachImage: 'Attach image',
    addEmoji: 'Add emoji',
    sendMessage: 'Send message',
    recordVoice: 'Record voice message',
    cancelRecording: 'Cancel voice recording',
    sendVoice: 'Send voice message',
    micNotSupported: 'Your browser does not support microphone access.',
    voiceNotSupported: 'Voice recording is not supported in this browser.',
    micAccessFailed: 'Could not access microphone. Please check permissions and try again.',
    newGroup: 'New group',
    newGroupDescription: 'Message several people at once',
    groupChat: 'Group chat',
    peopleYouKnow: 'People you know',
    loadingContacts: 'Loading contacts…',
    contactsLoadError: "Couldn't load contacts",
    tryAgain: 'Try again',
    noMatches: 'No matches',
    noMatchesHint: 'Try a different name or class.',
    searchContacts: 'Search contacts',
    searchByNameOrClass: 'Search by name or class…',
    chooseSomeone: 'Choose someone to message',
    chooseMembers: 'Choose members',
    groupDetails: 'Group details',
    stepOneOfTwo: 'Step 1 of 2',
    stepTwoOfTwo: 'Step 2 of 2',
    createGroup: 'Create group',
    goBack: 'Go back',
    searchMembers: 'Search members',
    selectedCount: '{{selected}} selected / {{limit}}',
    contactsCount: '({{count}} contacts)',
    selectTwoPeople: 'Select at least 2 people to create a group',
    maxParticipants: 'Maximum {{limit}} participants per group',
    addGroupPhoto: 'Add group photo',
    changeGroupPhoto: 'Change group photo',
    groupAvatarPreview: 'Group avatar preview',
    addPhoto: 'Add photo',
    removePhoto: 'Remove photo',
    groupName: 'Group name',
    groupNamePlaceholder: 'e.g. CS 101 study group',
    participants: 'Participants ({{count}})',
    groupInfo: 'Group info',
    info: 'Info',
    viewProfile: 'View profile',
    closeContactInfo: 'Close contact info',
    membersLabel: 'Members · {{count}}',
    admin: 'Admin',
    removeMember: 'Remove {{name}}',
    removeMemberConfirm: 'Remove {{name}} from {{group}}?',
    sharedMedia: 'Shared media',
    noSharedMedia: 'No shared media yet',
    deleteChatConfirm: 'Delete this chat?',
    exitGroupOwnerConfirm:
      'Exit "{{name}}"?\n\nSince you are the owner of this group, by leaving the group other members won\'t be able to chat.',
    exitGroupConfirm: 'Exit "{{name}}"?',
    exitGroup: 'Exit Group',
    deleteChat: 'Delete chat',
    notGroupMember: 'You are not a member of this group',
    ownSettingsBlock: "Your current settings don't allow you to message this user. Edit settings",
    promoterNoMessages: "This account doesn't receive messages",
    institutionDisabled: 'This feature has been disabled by your institution',
    userNoMessages: "This user doesn't want to receive private messages at the moment",
    unknownUserBanner: "You haven't chatted with this user before",
    block: 'Block',
    accept: 'Accept',
    undo: 'Undo',
    dismiss: 'Dismiss',
    selectMessages: 'Select messages',
    tapToAddRemove: '— tap to add or remove',
    forward: 'Forward',
    forwardWithCount: 'Forward ({{count}})',
    searchInConversationPlaceholder: 'Search in conversation…',
    searchMessageText: 'Search message text…',
    filterText: 'Text',
    filterMedia: 'Photos & video',
    filterFiles: 'Files',
    filterLinks: 'Links',
    filterAll: 'All',
    match_one: '{{count}} match',
    match_other: '{{count}} matches',
    messageOptionsAria: 'Message options',
    reply: 'Reply',
    download: 'Download',
    shareTo: 'Share to…',
    shareAction: 'Share',
    sharePhotosCount: '{{count}} photos',
    sharePhoto: 'Photo',
    shareVideo: 'Video',
    shareVoiceMessage: 'Voice message ({{duration}})',
    shareMessageFallback: 'Message',
    shareForwardOne: 'Forward message',
    shareForwardMany: 'Forward {{count}} messages',
    shareShareOne: 'Share message',
    shareShareMany: 'Share {{count}} messages',
    shareForwarded: 'Forwarded',
    shareSharedMany: '{{count}} messages shared',
    shareSharedOne: 'Message shared',
    shareSharedTo: 'to {{name}}. Open that chat to view {{pronoun}}.',
    shareChooseConversation: 'Choose a conversation',
    statusSending: 'Sending',
    statusSent: 'Sent',
    statusDelivered: 'Delivered',
    statusRead: 'Read',
    mediaUploading: 'Uploading…',
    statusFailed: 'Failed to send',
    emojiCategorySmileys: 'Smileys',
    emojiCategoryGesturesPeople: 'Gestures & people',
    emojiCategoryHeartsSymbols: 'Hearts & symbols',
    emojiCategoryAnimalsNature: 'Animals & nature',
    emojiCategoryFoodDrink: 'Food & drink',
    emojiCategoryTravelObjects: 'Travel & objects',
    pickEmojiAria: 'Pick an emoji',
    insertEmojiAria: 'Insert {{emoji}}',
    sharePronounIt: 'it',
    sharePronounThem: 'them',
    groupReadByOne: 'Read by {{name}}',
    groupReadByCount: 'Read by {{count}}',
    groupCloseReadListAria: 'Close read list',
    mediaViewerAria: 'Media viewer',
    mediaCounter: '{{current}} / {{total}}',
    preview: 'Preview',
    closeViewerAria: 'Close viewer',
    systemMemberAdded: '{{actor}} added {{target}}',
    systemMemberRemoved: '{{actor}} removed {{target}}',
    systemYouLeft: 'You left',
    systemMemberLeft: '{{actor}} left',
    systemAdminPromoted: '{{actor}} made {{target}} an admin',
    systemGroupCreatedNamed: '{{actor}} created "{{groupName}}"',
    systemGroupCreated: '{{actor}} created the group',
    systemDefaultActor: 'you',
    replyingTo: 'Replying to {{name}}',
    cancelReplyAria: 'Cancel reply',
    quickReactionsAria: 'Quick reactions',
    addReactionAria: 'Add reaction',
    retry: 'Retry',
    playVoiceMessage: 'Play voice message',
    pauseVoiceMessage: 'Pause voice message',
    playing: 'Playing…',
    noSearchMatches: 'No messages match your search.',
  },
  calendar: {
    loadingTimetable: 'Loading timetable…',
    noEvents: 'No events scheduled for this day',
    selectDate: 'Select calendar date',
    addEvent: 'Add calendar event',
    emptyTitle: 'No class events',
    emptyDescription: 'Scheduled events and due dates for this class will appear here.',
  },
  feed: {
    everyone: 'Everyone',
    filterByChild: 'Filter newsfeed by child',
    loadingFeed: 'Loading feed…',
    loadError: 'Couldn’t load the feed. Pull down to retry.',
    loadClassFeedError: 'Couldn’t load the class feed.',
    loadingMore: 'Loading more posts…',
    noMorePosts: 'No more posts',
    feedBreadcrumb: 'Feed',
    hashtagBreadcrumb: 'Hashtag',
    hashtagDescription: 'Public posts and class posts you can access that include this hashtag.',
    noPostsTitle: 'No posts yet',
    noPostsDescription: 'There are no posts with #{{tag}} in captions you can view.',
  },
  explore: {
    trendingPosts: 'Trending posts',
    noTrendingTitle: 'No trending posts yet',
    noTrendingDescription:
      'Posts from your school and network will appear here when there is activity to explore.',
    peopleYouMayKnow: 'People you may know',
    noSuggestionsTitle: 'No suggestions right now',
    noSuggestionsDescription:
      'People from your school will appear here when there are accounts to discover.',
    follow: 'Follow',
    requested: 'Requested',
    following: 'Following',
    followAria: 'Follow {{name}}',
    unfollowAria: 'Unfollow {{name}}',
    mutualConnection_one: '{{count}} mutual connection',
    mutualConnection_other: '{{count}} mutual connections',
  },
  createPost: {
    post: 'Post',
    postEvent: 'Post event',
    postQuestion: 'Post question',
    posting: 'Posting…',
    captionPlaceholder: "What's on your mind? Use #hashtags or @mentions",
    captionPlaceholderShort: "What's on your mind?",
    postCaptionAria: 'Post caption',
    eventCollapsedHint: 'Create an event with date, time, and optional Google Meet…',
    questionCollapsedHint: 'Ask a question with private responses…',
    composerTypeAria: 'Composer type',
    modePost: 'Post',
    modeQuestion: 'Question',
    modeEvent: 'Event',
    sentToTitle: 'Sent To',
    preparingPost: 'Preparing post…',
    uploadingMedia: 'Uploading media…',
    processingMedia: 'Processing media…',
    publishingPost: 'Publishing post…',
    imageSelectionCount: '{{count}} of {{limit}} images selected.',
    imageLimitReached: 'Image limit reached: {{count}} of {{limit}} images selected.',
    storageFullAttachmentNotice:
      'Your storage is full. You can still post images and audio, but videos and documents are unavailable.',
    publicFeed: 'Public feed',
    public: 'Public',
    anyoneFollowing: 'Anyone following you',
    follower_one: '{{count}} follower',
    follower_other: '{{count}} followers',
    publicExpandedHint: 'Visible to users who follow you on the public feed.',
    postToPublicAria: 'Post to public feed',
    yourClasses: 'Your classes',
    gradedClassHint:
      'Select at least one class and choose a grading category for each. Only recipients on the name list can submit private responses.',
    classLabel: 'Class',
    sendToAllMembersAria: 'Send to all members of {{className}}',
    selectClassAria: 'Select {{className}}',
    allMembersOfAria: 'All members of {{className}}',
    sendToMemberAria: 'Send to {{name}}',
    recipientsSelected_one: '{{count}} recipient selected.',
    recipientsSelected_other: '{{count}} recipients selected.',
    privateResponseHint:
      'Responses are visible only to you and each respondent — not on the public feed.',
    questionTitle: 'Question title',
    questionTitlePlaceholder: 'e.g. Chapter 5 reflection',
    instructions: 'Instructions',
    instructionsHint: 'Describe what recipients should submit. You can attach files below.',
    instructionsPlaceholder: 'What should recipients include in their response?',
    dueDate: 'Due date',
    dueTime: 'Due time',
    gradeResponses: 'Grade responses',
    gradedQuestionHint:
      'Graded questions can only be shared to classes. Only recipients on the class name list can submit private responses.',
    gradingTerm: 'Grading term',
    selectTerm: 'Select term',
    noGradingTerms: 'No grading terms are configured for your classes',
    gradingTermsLoadError: 'Couldn’t load grading terms',
    gradingCategoryNextStepHint:
      'You will choose the grading category and point value for each class on the next screen.',
    allowEditBeforeDue: 'Allow recipients to edit responses before the due date',
    chooseRecipients: 'Choose recipients',
    eventName: 'Event name',
    eventNamePlaceholder: 'Event name',
    allDay: 'All day',
    allDayDescription: 'Hide start and end times when enabled.',
    starts: 'Starts',
    startDate: 'Start date',
    ends: 'Ends',
    endDate: 'End date',
    time: 'Time',
    googleSignInTitle: 'Sign in to use Google features',
    googleSignInDescription:
      'As the event host, sign in with Google to attach a Meet link or save this event to your Google Calendar when you publish.',
    addGoogleMeet: 'Add Google Meet',
    meetEnabledDescription: 'A Meet link will be created when you publish.',
    meetDisabledDescription: 'Requires Google sign-in. Attendees can join without signing in.',
    addToCalendar: 'Add to your calendar',
    addToCalendarDescription: 'Save this event to your calendar when you publish.',
    phoneCalendar: 'Phone calendar',
    phoneCalendarDescription: 'Also offer a phone calendar download for recipients.',
    googleCalendar: 'Google Calendar',
    googleCalendarDescription:
      'Requires Google sign-in. Only added to your calendar, not recipients.',
    previewSignedOut: 'Preview signed-out state',
    previewSignedIn: 'Preview signed-in state',
    description: 'Description',
    descriptionHint: 'Optional. Attendees will see this on the event post.',
    descriptionPlaceholder: 'Add description',
    uploadPhotos: 'Upload photos',
    takePhoto: 'Take photo',
    uploadVideo: 'Upload video',
    recordVideo: 'Record video',
    uploadAudio: 'Upload audio',
    recordVoiceNote: 'Record voice note',
    uploadDocument: 'Upload document',
    photos: 'Photos',
    video: 'Video',
    addDocument: 'Add document',
    voice: 'Voice',
    mentionSomeone: 'Mention someone',
    noMatches: 'No matches',
    noMatchesHint: 'Try another name or handle.',
    gradingForClass: 'Grading for this class',
    category: 'Category',
    selectCategory: 'Select category',
    totalGrade: 'Total grade',
    previewAttachmentAria: 'Preview {{name}}',
    removeAttachmentAria: 'Remove {{name}}',
    takePhotoTitle: 'Take photo',
    startingCamera: 'Starting camera…',
    cameraPreview: 'Camera preview',
    capturing: 'Capturing…',
    capturePhoto: 'Capture photo',
    recordVideoTitle: 'Record video',
    recordedVideoPreview: 'Recorded video preview',
    recLabel: 'REC {{duration}}',
    stopRecording: 'Stop recording',
    startRecording: 'Start recording',
    retake: 'Retake',
    addVideo: 'Add video',
    videoNotSupported: 'Video recording is not supported in this browser.',
    recordVoiceTitle: 'Record voice note',
    startingMicrophone: 'Starting microphone…',
    voicePreview: 'Voice preview',
    recordAgain: 'Record again',
    addVoiceNote: 'Add voice note',
    voiceNotSupported: 'Voice recording is not supported in this browser.',
    mediaNotSupported: 'Camera and microphone are not supported in this browser.',
    mediaAccessFailed: 'Could not access camera or microphone. Check permissions and try again.',
    validationQuestionTitleRequired: 'Add a question title.',
    validationDueDateRequired: 'Select a due date.',
    validationDueTimeRequired: 'Select a due time.',
    validationGradingTermRequired: 'Select a grading term.',
    validationSelectGradingCategory: 'Select a grading category for this class.',
    validationTotalGradeInvalid: 'Enter a valid total grade for this class.',
    validationEventNameRequired: 'Event name is required.',
    validationStartDateRequired: 'Start date is required.',
    validationEndDateRequired: 'End date is required.',
    validationTimesRequired: 'Start and end times are required.',
    validationEndAfterStart: 'End must be after the start.',
    validationGoogleSignInRequired:
      'Sign in with Google to add Google Meet or save to Google Calendar.',
    errorLoadingClasses: 'Loading your classes — please try again in a moment.',
    errorSelectAudience: 'Select at least one audience.',
    errorSelectClass: 'Select at least one class.',
    errorInvalidDueDate: 'Invalid due date.',
    errorInvalidEventDateTime: 'Invalid event date/time.',
    errorPublishQuestionFailed: 'Failed to publish question.',
    errorPublishPostFailed: 'Failed to publish post.',
    errorPublishEventFailed: 'Failed to publish event.',
  },
  profile: {
    profileNotFoundTitle: 'Profile not found',
    profileNotFoundDescription: 'This user does not exist or their profile is not available.',
    profileUnavailableTitle: 'Profile unavailable',
    profileUnavailableDescription:
      'You have blocked this account. Unblock them from Settings to view their profile again.',
    loadingProfileAria: 'Loading profile',
    loadingPosts: 'Loading posts…',
    postsLoadError: 'Couldn’t load this profile’s posts.',
    noPostsYet: 'No posts yet',
    noPosts: 'No posts',
    noPostsOwnDescription: 'Share an update with your classes or the public feed.',
    noPostsOtherDescription: 'This user has not posted anything yet.',
    writePost: 'Write a post',
    privateAccount: 'Private account',
    privateAccountFollowingDescription:
      'This account is private. Post and connection lists will appear here when available to followers.',
    privateAccountFollowDescription:
      'Counts are shown above, but follow this account to view their posts, following, followers, and joined classes.',
    follow: 'Follow',
    classOf: 'Class of {{year}}',
    classesSectionTitle: "{{name}}'s classes",
    shareProfile: 'Share profile',
    shareProfileAria: 'Share profile',
    qrCodeAria: 'QR code for profile link',
    linkCopied: 'Link copied',
    copyProfileLink: 'Copy profile link',
    flyerDownloaded: 'Flyer downloaded',
    downloadProfileFlyer: 'Download profile flyer',
    leaveClass: 'Leave class',
    leaveClassAria: 'Leave class',
    leaveClassConfirm:
      'Leave {{className}}? You will lose access to class content, posts, and members until you join again.',
    editProfile: 'Edit profile',
    profileDetails: 'Profile details',
    profileDetailsDescription:
      'Update how others see you on MyU. Some fields may be locked by your school.',
    firstName: 'First name',
    lastName: 'Last name',
    username: 'Username',
    usernameHint: 'Letters, numbers, and underscores only.',
    institution: 'Institution',
    selectInstitution: 'Select institution',
    searchInstitutions: 'Search institutions…',
    institutionOptions: 'Institution options',
    bio: 'Bio',
    bioRemaining: '{{count}} characters remaining',
    bioPlaceholder: 'Tell others a little about yourself',
    personalInfo: 'Personal information',
    personalInfoDescription: 'Private details used for account recovery and school records.',
    email: 'Email',
    mobileNumber: 'Mobile number',
    mobilePlaceholder: '+1 555 000 0000',
    gender: 'Gender',
    dateOfBirth: 'Date of birth',
    changePassword: 'Change password',
    lockedFieldHint: 'This field is managed by your school administrator.',
    genderFemale: 'Female',
    genderMale: 'Male',
    genderNonBinary: 'Non-binary',
    genderPreferNotToSay: 'Prefer not to say',
    currentPassword: 'Current password',
    newPassword: 'New password',
    newPasswordPlaceholder: 'At least 6 characters (letters, numbers, _ # @)',
    confirmNewPassword: 'Confirm new password',
    passwordTooShort: 'Password must be at least 6 characters.',
    passwordInvalidChars: 'Only letters, numbers, and the symbols _ # @ are allowed.',
    passwordsMismatch: 'Passwords do not match.',
    passwordUpdated: 'Your password has been updated.',
    updatingPassword: 'Updating…',
    updatePassword: 'Update password',
    enterCurrentPassword: 'Enter your current password.',
    newPasswordMinLength: 'New password must be at least 6 characters.',
    newPasswordInvalidChars: 'New password can only contain letters, numbers, and _ # @.',
    newPasswordMustDiffer: 'New password must be different from your current password.',
    mustBeSignedIn: 'You must be signed in to change your password.',
    passwordUpdateFailed: 'Failed to update password.',
    manageCategories: 'Manage categories',
    manageCategoriesAria: 'Manage categories',
    sortingCategoryOrder: 'Sorting category order',
    sortingUncategorized: 'Sorting uncategorised classes',
    sortingClassesIn: 'Sorting classes in {{name}}',
    doneSorting: 'Done sorting',
    sortCategoryOrderHint: 'Use Up and Down to change the order categories appear on your profile.',
    uncategorizedTopHint:
      'These classes appear at the top of your profile when not in any category.',
    noUncategorizedClasses: 'No uncategorised classes.',
    sortClassesInCategoryHint:
      'Use Up and Down to change the order of classes inside this category.',
    noClassesInCategory: 'No classes in this category yet.',
    loadingCategories: 'Loading categories…',
    categoriesLoadError: 'Couldn’t load your categories. Showing the latest known list.',
    uncategorizedClasses: 'Uncategorised classes',
    atTopOfProfile: '{{count}} at top of profile',
    sortOrder: 'Sort order',
    allClassesInCategory: 'All classes are in a category.',
    categoryName: 'Category name',
    class_one: '{{count}} class',
    class_other: '{{count}} classes',
    sortClasses: 'Sort classes',
    archive: 'Archive',
    delete: 'Delete',
    remove: 'Remove',
    tickClassesHint: 'Tick classes to include. A class can only belong to one category.',
    alreadyInAnotherCategory: 'Already in another category',
    newCategory: 'New category',
    newCategoryPlaceholder: 'e.g. STEM Classes',
    addCategory: 'Add category',
    addingCategory: 'Adding…',
    saveChanges: 'Save changes',
    untitledCategory: 'Untitled category',
    expandCategory: 'Expand category',
    collapseCategory: 'Collapse category',
    up: 'Up',
    down: 'Down',
    sortCategoryOrder: 'Sort category order',
    categoryNamesUnique: 'Category names must be unique.',
    couldNotAddCategory: 'Could not add category. Please try again.',
    couldNotSaveChanges: 'Could not save your changes. Please try again.',
    yourClassesAria: 'Your classes',
    yourClasses: 'Your classes ({{count}})',
    organiseCategories: 'Organise categories & order',
    noClassesToShow: 'No classes to show.',
    addClass: 'Add class',
    editClass: 'Edit class',
    shareClass: 'Share class',
    privateClass: 'Private class',
    changeProfilePhoto: 'Change profile photo',
    actionsFor: 'Actions for {{name}}',
    posts: 'posts',
    members: 'members',
    joined: 'Joined',
    requested: 'Requested',
    join: 'Join',
    following: 'Following',
    message: 'Message',
    block: 'Block',
    moreActionsFor: 'More actions for {{name}}',
    accountTypeStudent: 'Student',
    accountTypeInstructor: 'Instructor',
    accountTypeManagement: 'Staff',
    accountTypePromoter: 'Promoter',
    accountTypeParent: 'Parent',
    accountTypeTutor: 'Tutor',
  },
  notifications: {
    title: 'Notifications',
    description: 'Review class requests and invites first, then catch up on recent activity.',
    needsAttention: 'Needs your attention',
    requestedToFollow: 'requested to follow you',
    requestedToJoinClass: 'requested to join your class',
    classJoinRequests: 'Class Join requests',
    classJoinRequestsDescription: 'Approve or decline members who want to join your classes.',
    classFollowRequests: 'Follow requests',
    classFollowRequestsDescription: 'Approve or decline people who want to follow your profile.',
    classAdminInvites: 'Class Admin Invites',
    classAdminInvitesDescription: 'Accept or decline invitations to help manage a class.',
    recentActivity: 'Recent activity',
    tabFollowing: 'Following',
    tabYou: 'You',
    yourNotificationsAria: 'Your notifications',
    followingActivityAria: 'Following activity',
    loadError: 'Couldn’t load notifications',
    emptyTitle: 'No notifications yet',
    emptyYouDescription: 'Activity about your posts and classes will appear here.',
    emptyFollowingDescription: 'Updates from people you follow will appear here.',
    requestedToJoin: 'Requested to join',
    adminInviteFor: 'Admin invite for',
    approve: 'Approve',
    decline: 'Decline',
    accept: 'Accept',
    pending_one: '{{count}} pending',
    pending_other: '{{count}} pending',
    andOther_one: ' and 1 other',
    andOther_other: ' and {{count}} others',
    pendingRequest_one: '{{count}} pending request',
    pendingRequest_other: '{{count}} pending requests',
    notificationsAria: 'Notifications',
    notificationsPendingAria: 'Notifications, {{count}} pending',
    likedYourPost: 'liked your post',
    commentedOnYourPost: 'commented on your post',
    mentionedYouInComment: 'mentioned you in a comment',
    startedFollowingYou: 'started following you',
    joinedYourClass: 'joined your class:',
    createdNewClass: 'created a new class:',
    nowAdminOfClass: 'is now an admin of your class:',
    invitedYouAsAdmin: 'invited you to be an admin of',
  },
  prime: {
    title: 'MyU Prime',
    goBack: 'Go back',
    activePlan: 'Active plan',
    defaultPlanName: 'MyU Prime · 1 year',
    activeUntil: 'Your premium access is active until {{date}}.',
    noAutoRenewNote:
      'There is no auto-renewal. You can purchase another year from this page when your plan ends.',
    manageInSettings: 'Manage in Settings',
    annualPlan: 'Annual plan',
    loadingPlan: 'Loading annual plan…',
    planUnavailable: 'The annual package is unavailable right now. Please try again later.',
    oneTimePayment: 'One-time payment · {{gb}} GB storage · all premium features',
    subscribe: 'Subscribe · {{label}}',
    redirectingCheckout: 'Activating Prime…',
    checkoutError: 'Unable to activate Prime right now. Please try again.',
    agreePrefix: 'By upgrading you agree to our',
    privacyPolicy: 'privacy policy',
    and: 'and',
    termsOfService: 'terms of service',
    previousFeature: 'Previous feature',
    nextFeature: 'Next feature',
    featuresAria: 'Prime features',
    featureTabAria: '{{title}} ({{index}} of {{total}})',
    valuePointStorage: '{{gb}} GB storage for documents and media',
    valuePointNoAutoRenew: 'No auto-renewal — you stay in control',
    valuePointSecureCheckout: 'Secure checkout powered by TAP',
    checkoutNoteTap: 'Payment is processed securely through TAP.',
    checkoutNoteOneYear: 'Your subscription lasts one year from the purchase date.',
    checkoutNoteNoAutoRenew: 'There is no auto-renewal — renew manually when your plan ends.',
    checkoutNoteActiveUntil: 'Premium features stay active until the end of your paid period.',
    featureStorageTitle: 'Get more space',
    featureStorageDescription: 'Enjoy an extra 100 GB of space and share more documents.',
    featureStorageAlt: 'MyU owl mascot with extra document storage',
    featureVideoTitle: 'Longer videos',
    featureVideoDescription: 'Add up to 30 minutes of video on every post.',
    featureVideoAlt: 'MyU owl mascot recording longer videos',
    featurePhotosTitle: 'Add more photos to your posts',
    featurePhotosDescription: 'Attach up to 20 photos from your gallery at a time.',
    featurePhotosAlt: 'MyU owl mascot adding more photos to a post',
    featureClassesTitle: 'Create more classes',
    featureClassesDescription: 'Add up to 12 additional classes to your profile.',
    featureClassesAlt: 'MyU owl mascot creating more classes',
    featureInvisibleReaderTitle: 'Invisible reader',
    featureInvisibleReaderDescription:
      'Read chat messages without the other person knowing you saw them.',
    featureInvisibleReaderAlt: 'MyU owl mascot with invisible chat reader',
    featureAdFreeTitle: 'Ad-free experience',
    featureAdFreeDescription: 'Enjoy using MyU without seeing any ads.',
    featureAdFreeAlt: 'MyU owl mascot with an ad-free phone experience',
    featureExploreTitle: 'Rank higher',
    featureExploreDescription:
      'Make it easy for others to find you on Explore by showing higher on every list.',
    featureExploreAlt: 'MyU owl mascot ranking higher on Explore',
    featureAttendanceTitle: 'Take unlimited attendance',
    featureAttendanceDescription:
      'Enjoy unlimited attendance sessions and reports for all your classes.',
    featureAttendanceAlt: 'MyU owl mascot taking unlimited attendance',
    featureHistoryTitle: 'Keep your messaging history',
    featureHistoryDescription:
      "You won't lose prior records, and you can revisit old messages at any time.",
    featureHistoryAlt: 'MyU owl mascot preserving messaging history',
    featureMembersTitle: 'Send to more people',
    featureMembersDescription: 'Raise the maximum class size from 500 to 5,000 members.',
    featureMembersAlt: 'MyU owl mascot sending posts to more people',
    featureNetworkTitle: 'Expand your network',
    featureNetworkDescription:
      'Connect with students from other schools and expand your influence.',
    featureNetworkAlt: 'MyU owl mascot expanding their network',
  },
  class: {
    emptyPostsTitle: 'No posts yet',
    emptyPostsDescription: 'Posts shared with this class will appear here.',
    emptyMembersTitle: 'No members yet',
    emptyMembersDescription:
      'Students, instructors, parents, and other accounts connected to this class will appear here.',
    emptyRosterTitle: 'No students on the roster',
    emptyRosterDescription: 'Roster entries for this class will appear here.',
    emptyAttendanceTitle: 'No attendance records',
    emptyAttendanceDescription: 'Attendance sessions and history for this class will appear here.',
    emptyProgressTitle: 'No progress reports',
    emptyProgressDescription:
      'Report templates and submitted progress for this class will appear here.',
    emptyBehaviourTitle: 'No behaviour entries',
    emptyBehaviourDescription: 'Behaviour points and activity for this class will appear here.',
    emptyGradesTitle: 'No grades set up',
    emptyGradesDescription: 'Grading terms, categories, and items for this class will appear here.',
    emptyResourcesTitle: 'No resources',
    emptyResourcesDescription: 'Files and materials shared in this class will appear here.',
    sectionsNavAria: 'Class sections',
    scrollTabsLeftAria: 'Scroll tabs left',
    scrollTabsRightAria: 'Scroll tabs right',
    tabPosts: 'Posts',
    tabMembers: 'Members',
    tabRoster: 'Roster',
    tabAttendance: 'Attendance',
    tabProgress: 'Progress',
    tabBehaviour: 'Behaviour',
    tabGrades: 'Grades',
    tabCalendar: 'Calendar',
    tabResources: 'Resources',
    formEditTitle: 'Edit class',
    formCreateTitle: 'Create class',
    formCreateSubmit: 'Create class',
    formClassTypeLabel: 'Class type',
    formSelectClassType: 'Select class type',
    formClassNameLabel: 'Class name',
    formCharactersRemaining: '{{count}} characters remaining',
    formClassNamePlaceholder: 'e.g. Math 10 A',
    formAcademicYearLabel: 'Academic year',
    formSelectAcademicYear: 'Select academic year',
    formSubjectLabel: 'Subject',
    formSubjectHint: 'Optional — search to find a subject quickly',
    formSelectSubjectOptional: 'Select subject (optional)',
    formSearchSubjects: 'Search subjects…',
    formNoSubject: 'No subject',
    formGradeLabel: 'Year/Grade',
    formSelectGrade: 'Select year or grade',
    formCreditsLabel: 'Credits',
    formCreditsPlaceholder: 'e.g. 3',
    formPrivateLabel: 'Private class',
    formPrivateDescription: 'A private class can only be accessed by authorised members.',
    formNotifyFollowersLabel: 'Notify followers',
    formNotifyFollowersDescription:
      'If checked, followers will be notified about the class creation.',
    formArchivedLabel: 'Archived class',
    formArchivedDescription:
      'This class is hidden from your sidebar and profile. Move it to your profile to make it active again, or delete it permanently.',
    formRestoreClass: 'Restore class',
    formMoveToProfile: 'Move to profile',
    formDeleteClass: 'Delete class',
    formDangerZone: 'Danger zone',
    formDangerZoneDescription:
      'Archiving hides this class from your sidebar and profile. You can restore it from Settings. Deleting is permanent and cannot be undone.',
    formArchiveClass: 'Archive class',
    validationSelectClassType: 'Select a class type.',
    validationEnterClassName: 'Enter a class name.',
    validationClassNameMaxLength: 'Class name must be {{max}} characters or fewer.',
    validationSelectAcademicYear: 'Select an academic year.',
    validationSelectGrade: 'Select a year or grade.',
    validationInvalidCredits: 'Credits must be a valid number (0 or greater).',
    typeHomeroom: 'Homeroom/Form Class',
    typeSubject: 'Subject Class',
    typeCommunication: 'Communication Channel',
    typeSubmodule: 'Sub-module',
    shareTitle: 'Share class',
    shareCodeLabel: 'Code: {{code}}',
    shareQrAria: 'QR code to join {{className}}',
    shareCopyLink: 'Copy class link',
    shareCopyCode: 'Copy class code',
    membersAddModalAria: 'Add class members',
    membersAddModalTitle: 'Add members',
    membersSearchPlaceholder: 'Search by name or username…',
    membersSearchAria: 'Search users',
    membersShownCount: '{{shown}} of {{total}} shown',
    membersLoadingPeople: 'Loading people…',
    membersAllAlreadyAdded: 'Everyone available is already in this class.',
    membersAdding: 'Adding…',
    membersAddToClass: 'Add to class',
    membersAddToClassWithCount: 'Add to class ({{count}})',
    roleOwner: 'Class Owner',
    roleAdmin: 'Class Admin',
    membersFallbackName: 'Member',
    membersSectionTitle: 'Class Members ({{count}})',
    membersAddMember: 'Add Member',
    membersShareClass: 'Share class',
    membersLoadError: 'Failed to load class members.',
    membersEmptyInline: 'No members yet.',
    membersCandidatesLoadError: 'Failed to load people to add.',
    adminRequestPending: 'Admin request pending',
    cancelAdminRequest: 'Cancel request',
    removeAdmin: 'Remove admin',
    makeAdmin: 'Make admin',
    removeFromClass: 'Remove from class',
    memberActionsFor: 'Actions for {{name}}',
    studentIdLabel: 'Student ID {{id}}',
    rosterLinkAccountAria: 'Link class member to roster student',
    rosterLinkAccountTitle: 'Link account — {{studentName}}',
    rosterLinkAccountDescription:
      'Choose a class member to link with this roster student. Linked members can be removed later.',
    rosterAllMembersLinked: 'All class members are already linked.',
    rosterClassMembersListAria: 'Class members',
    rosterLinkAccount: 'Link account',
    rosterEditStudentAria: 'Edit {{studentName}}',
    rosterEditStudentTitle: 'Edit roster student',
    rosterStudentNameLabel: 'Student name',
    rosterNameRequired: 'Student name is required.',
    rosterStudentIdLabel: 'Student ID',
    rosterStudentIdPlaceholder: 'e.g. S12345',
    rosterAddStudentsAria: 'Add students to roster',
    rosterAddStudentsTitle: 'Add students',
    rosterMethodManual: 'Enter manually',
    rosterMethodDirectory: 'Institution directory',
    rosterMethodMembers: 'Class members',
    rosterMethodCsv: 'CSV file',
    rosterFullNamePlaceholder: 'Full name',
    rosterDirectoryDescription: 'Select students from your institution directory.',
    rosterSearchDirectoryPlaceholder: 'Search by name or student ID…',
    rosterSearchDirectoryAria: 'Search institution directory',
    rosterShownSelected: '{{shown}} of {{total}} shown · {{selected}} selected',
    rosterSelectAll: 'Select all',
    rosterDeselectAll: 'Deselect all',
    rosterMembersDescription:
      'Add existing class members to the roster (creates a roster entry from their profile).',
    rosterSearchMembersPlaceholder: 'Search by name, ID, or role…',
    rosterSearchMembersAria: 'Search class members',
    rosterFallbackMember: 'Member',
    rosterCsvInstructions: 'Upload a CSV file, then select which column contains the student name.',
    rosterCsvFileLabel: 'CSV file',
    rosterCsvExcludeFirstRow: 'Exclude the sheet first row',
    rosterCsvSelectNameColumn: 'Select the student name column (mandatory)',
    rosterCsvSelectIdColumn: 'Select the student ID column (optional)',
    rosterCsvReadyToImport: '{{fileName}} — {{count}} student(s) ready to import',
    rosterCsvNoValidRows: 'No valid rows found.',
    rosterCsvReadError: 'Could not read the file.',
    rosterCsvUploadFirst: 'Upload a CSV file first.',
    rosterCsvPreview: 'Preview selection',
    rosterCsvPreviewTitle: 'Preview selection',
    rosterAddStudent: 'Add student',
    rosterImportStudents: 'Import students',
    rosterImportStudentsCount: 'Import {{count}} students',
    rosterAddSelected: 'Add selected',
    rosterNoSearchMatches: 'No matches for your search.',
    rosterUnlinkTitle: 'Unlink account',
    rosterUnlinkMessage:
      'Remove the link between roster student {{rosterName}} and class member {{memberName}}? They will stay on the roster and in the class separately.',
    rosterUnlinkConfirm: 'Unlink account',
    rosterRemoveTitle: 'Remove from roster',
    rosterRemoveMessage:
      'Remove {{name}} from the class roster? Linked class members may also be affected.',
    rosterRemoveConfirm: 'Remove student',
    shareCodeCopied: 'Code copied',
    rosterTitle: 'Class roster ({{count}})',
    rosterSortAria: 'Sort roster',
    rosterSortAz: 'Sort A–Z',
    rosterSortZa: 'Sort Z–A',
    rosterSortManual: 'Manual order',
    rosterSortList: 'Sort list',
    rosterEditStudent: 'Edit student',
    rosterRemoveFromRoster: 'Remove from roster',
    rosterLinkedAccounts: 'Linked accounts:',
    rosterLinkedNone: 'None',
    rosterUnlinkMemberAria: 'Unlink {{name}}',
    rosterActionsForAria: 'Actions for {{name}}',
    rosterStudentIdPrefix: 'ID: {{id}}',
  },
  search: {
    placeholder: 'Search…',
    resultTypeAria: 'Search result type',
    tabUsers: 'Users',
    tabClasses: 'Classes',
    usersLoadError: "Couldn't load results. Please try again.",
    classesLoadError: "Couldn't load classes. Please try again.",
    updating: 'Updating…',
    searching: 'Searching…',
    noUsersFound: 'No users found. Try a different name or username.',
    noClassesFound: 'No classes found. Search by class code (e.g. CS101).',
  },
  payments: {
    loading: 'Loading payment details…',
    loadError: 'Could not load payment details. Please try again.',
    noPrograms: 'No enrolled programs with payable fees were found.',
    noProducts: 'No products are available right now.',
    sectionsAria: 'Payment sections',
    tabEnrolled: 'Enrolled program',
    tabProducts: 'Other Products',
    tabHistory: 'Payment history',
    paymentSubmitted: 'Payment completed successfully. Your payment reference is confirmed.',
    paymentFailed: 'Payment was not completed. Your cart has been kept so you can try again.',
    paymentPending: 'Payment is still being confirmed. Please check again shortly.',
    productDateCannotBePast: 'Select today or a future date.',
    historyLoading: 'Loading payment history…',
    historyLoadError: 'Could not load payment history. Please try again.',
    historyEmpty: 'No payments have been recorded for your linked students yet.',
    historyMoreLines: '+{{count}} more items',
    downloadReceipt: 'Download receipt',
    receiptPreparing: 'Preparing receipt…',
    receiptTitle: 'Payment receipt',
    receiptSubtitle: 'Official payment confirmation',
    receiptReference: 'Reference',
    receiptDate: 'Date',
    receiptAmount: 'Amount',
    receiptPaymentMode: 'Payment method',
    receiptSource: 'Recorded by',
    receiptSourceParent: 'Online (parent)',
    receiptSourceAdmin: 'School office',
    receiptThankYou: 'Thank you for your payment.',
    receiptPrintedOn: 'Printed on',
    receiptReceived: 'Received',
    receiptBrand: 'MyU',
    filterByCategoryAria: 'Filter by category',
    filterByStudentAria: 'Filter by student',
    filterAll: 'All',
    backToCartAria: 'Back to cart',
    backToPaymentsAria: 'Back to payments',
    assignToStudentTitle: 'Assign to student',
    assignProductAria: 'Assign {{productName}} to students',
    includeItemAria: 'Include {{label}}',
    addForAnotherStudentAria: 'Add for another student',
    amountPlaceholder: 'Amount',
    customAmountAria: 'Custom amount for {{label}}',
    customAmountTooHigh: 'Amount cannot exceed {{amount}}',
    receiptDetails: 'Details',
    receiptStatus: 'Status',
    refundLabel: 'Refund',
    walletRefundLabel: 'Wallet refund',
    refundDetails: 'Refund: {{status}}{{amount}}{{method}}',
    quantityLabel: 'Quantity: {{count}}',
    selectFeeAria: 'Select {{label}}',
    paid: 'Paid',
    partiallyPaid: 'Partially paid',
    paidAmount: 'Paid: {{amount}}',
    discountedTotal: 'After discount: {{amount}}',
    remainingDue: 'Due: {{amount}}',
    discountCode: 'Discount: {{code}}',
    discountValue: '{{value}} off',
    cartAria: 'Shopping cart',
    cartWithItemsAria: 'Shopping cart, {{count}} items',
    shoppingCart: 'Shopping Cart',
    checkout: 'Checkout',
    nothingToCheckout: 'Nothing to checkout. Add items to your cart first.',
    viewCart: 'View cart',
    qty: 'Qty',
    studentLabel: 'Student',
    cartEmpty: 'Your cart is empty. Select fees or products to continue.',
    add: 'Add',
    orderSummary: 'Order summary',
    total: 'Total',
    proceedToCheckout: 'Proceed to checkout',
    proceedToPayment: 'Proceed to payment',
    reviewOrder: 'Review your order',
    paymentSecureNote:
      'Payment is processed securely through TAP. You will be redirected to complete your payment.',
    openingPayment: 'Opening secure payment…',
    paymentInitiationError: 'Could not start the payment. Please try again.',
    feeItem: 'Item',
    feeDueDate: 'Due date',
    feeAmount: 'Amount',
    studentIdPrefix: 'ID {{id}}',
    balanceForwardApplied: 'Wallet balance applied: {{amount}}',
    walletBalanceLabel: 'Wallet balance',
    walletBalanceDescription: 'Credit available after program removal and other adjustments.',
    applyWallet: 'Use wallet balance',
    applyingWallet: 'Applying wallet…',
    walletAvailable: '{{amount}} available',
    walletApplyError: 'Could not apply the wallet balance. Please try again.',
    cartPreviewTitle: 'Your cart',
    cartPreviewEmpty: 'No items added yet.',
    selectAllStudents: 'Select all students',
    unselectAllStudents: 'Unselect all students',
    assignStudentsHint: 'Select one or more students for {{productName}}.',
    assignAllAssigned: 'This item is already assigned to all students with these options.',
    selectDay: 'Select day',
    selectSize: 'Select size',
    size: 'Size',
    selectOptions: 'Select options',
    requiredProductOption: 'This field is required.',
    addToCart: 'Add to cart',
    outOfStock: 'Out of stock',
    quantityAvailable: 'Maximum available quantity: {{count}}',
    inventoryExceeded: 'The requested quantity for {{product}} is no longer available.',
  },
  reportCards: {
    title: 'Report Cards',
    subtitle: 'View and download progress reports for your linked students.',
    documents: 'Documents',
    filterByStudentAria: 'Filter by student',
    filterByYearAria: 'Filter by academic year',
    yearFallback: 'Year',
    studentIdLabel: 'Student ID {{id}}',
    loading: 'Loading report cards…',
    loadErrorTitle: "Couldn't load report cards",
    loadErrorDescription: 'Please check your connection and try again.',
    noStudentsTitle: 'No linked students',
    noStudentsDescription:
      'Report cards appear here when students are linked to your parent account.',
    nothingTitle: 'Nothing to show',
    pdfDocument: 'PDF document',
    noReportsForYear: 'No report cards are available for this academic year.',
  },
  grades: {
    gradingTerms: 'Grading Terms',
    addTerm: 'Add Term',
    editTerm: 'Edit Term',
    deleteTerm: 'Delete Term',
    deleteTermConfirm:
      'Delete {{name}}? This removes the grading term and its category weightings for this class. Grade items in the term may also be affected.',
    deletingTerm: 'Deleting…',
    savingTerm: 'Saving…',
    selectYear: 'Academic year',
    selectYearPlaceholder: 'Select year',
    termTitleLabel: 'Term title',
    termTitlePlaceholder: 'Term title (e.g. Quarter 1)',
    categoriesAndWeightage: 'Grading categories and weightage',
    addCategory: 'Add category',
    addOrEditCategories: 'Add or edit categories',
    selectGradingCategories: 'Select grading categories',
    selectCategoryFromList: 'Please select at least one category from the list.',
    selectGradingCategory: 'Please select at least one grading category.',
    missingInfo: 'Missing info',
    categoryWeightageEmpty: 'Category weightage cannot be empty.',
    categoryWeightageMustEqual100: 'Total category weightage must equal 100.',
    weightTotal: 'Total: {{total}} / 100',
    categoryWeightFor: 'Weight for {{name}}',
    noCategoriesSelected: 'No categories selected yet.',
    loadingTerms: 'Loading grading terms…',
    loadTermsError: 'Failed to load grading terms. Showing preview data.',
    noTermsYet: 'No grading terms yet.',
    loadingGradeItems: 'Loading grade items…',
    loadGradeItemsError: 'Failed to load grade items. Showing preview data.',
    loadingCategories: 'Loading categories…',
    noCategoriesInTerm: 'No categories configured for this term.',
    termActionsFor: 'Actions for {{name}}',
    report: 'Report',
    generatingReport: 'Generating…',
    viewReport: 'View Report',
    emailReport: 'Email Report',
    emailingReport: 'Sending…',
    reportDialogTitle: 'Grade Report',
    reportDialogAria: 'Grade report options',
    reportDialogMessage: 'How would you like to view your grades report?',
    emailReportConfirmTitle: 'Email Grades Report',
    emailReportConfirmMessage:
      'Would you like to receive the full grades report for this class at your email address?',
    reportEmailed: 'Report emailed!',
    reportEmailError: 'Failed to send grade report. Please try again.',
    viewGradeItem: 'Grade Details',
    editGradeItem: 'Edit Grade',
    permissionDeniedTitle: 'Action not allowed',
    permissionDeniedEditMessage:
      "You don't have permission to perform this action. Please contact your school administrator if you need access.",
    addGradeItem: 'Add Grade Title',
    deleteGrade: 'Delete Grade',
    deleteGradeConfirm: 'Delete grade',
    deleting: 'Deleting…',
    loadGradeDetailsError: 'Failed to load grade details. Please try again.',
    itemTitle: 'Grade Title',
    fullGrade: 'Full Grade',
    itemNamePlaceholder: 'e.g., Quiz 1, Exam 1',
    maxGradePlaceholder: 'e.g., 100',
    studentGrades: 'Student Grades',
    loadingStudents: 'Loading students…',
    noStudentsEnrolled: 'No students enrolled.',
    gradeLabel: 'Grade',
    noteLabel: 'Note',
    gradePlaceholder: '0',
    addNoteOptional: 'Add note (optional)',
    closeEditorAria: 'Close editor',
    locked: 'Locked',
    pendingAdminApproval: 'Pending admin approval',
    fullMark: 'Full mark ({{count}})',
    averageGrade: 'Average grade ({{value}}%)',
    totalMark: 'Total mark ({{count}})',
    weight: 'Weight ({{value}}%)',
    termCategorySummary: '{{count}} grading categories •',
    studentGradesEmpty: 'When your grade is posted, you will see it here.',
    studentGradesEmptyTitle: 'No grades yet',
    studentGradesUnlinkedTitle: 'Account not linked',
    studentGradesUnlinkedDescription:
      'To view your grades, ask the class owner to link your account with your name on the roster.',
    studentGradesErrorHint: 'Please try again later.',
    loadCategoriesError: 'Failed to load categories. Please try again.',
  },
  behaviour: {
    title: 'Behaviour Points',
    managePoints: 'Manage Points',
    loading: 'Loading behaviour points…',
    loadError: 'Failed to load behaviour points.',
    selectStudentOrTeam: 'Select student or team',
    selectCategory: 'Select category',
    saving: 'Saving…',
    save: 'Save',
    select: 'Select',
    selected: 'Selected',
    searchTeamsPlaceholder: 'Search teams…',
    searchStudentsPlaceholder: 'Search students…',
    searchTeamsAria: 'Search teams',
    searchStudentsAria: 'Search students',
    noTeamsConfigured: 'No teams configured for this class.',
    noTeamsMatch: 'No teams match your search.',
    noStudentsEnrolled: 'No students enrolled in this class.',
    noStudentsMatch: 'No students match your search.',
    noCategoriesAvailable: 'No categories available.',
    noCategoryTab: 'No {{tab}} categories.',
    managePointsSubtitle: 'Award or deduct points for students or teams',
    pointsToAward: 'Points to award',
    closeManagePointsAria: 'Close manage points',
    addCommentsPlaceholder: 'Add comments (optional)',
    closePickerAria: 'Close picker',
    selectTeamsOrStudentsAria: 'Select teams or students',
    teamsShownCount: '{{shown}} of {{total}} teams',
    studentsShownCount: '{{shown}} of {{total}} students',
    selectedCountSuffix: ' · {{count}} selected',
    loadStudentsTeamsError: 'Failed to load students and teams. Please try again.',
    categoryTypeAria: 'Category type',
    loadCategoriesError: 'Failed to load categories. Please try again.',
    categoryTabPositive: 'Positive',
    categoryTabNegative: 'Negative',
    loadingPoints: 'Loading points…',
    loadPointsError: 'Failed to load points.',
    noPointsRecorded: 'No points recorded yet',
    teamLabel: 'Team:',
  },
  attendance: {
    takeAttendance: 'Take Attendance',
    newAttendance: 'New Attendance',
    hideCodeAria: 'Hide attendance code',
    showCodeAria: 'Show attendance code',
    useDefaultWindow: 'Use default time window',
    useCurrentTime: 'Use current time',
    saving: 'Saving…',
    save: 'Save',
    deleting: 'Deleting…',
    delete: 'Delete',
    editDateTime: 'Edit date and time',
    editAttendanceConfirmTitle: 'Edit attendance',
    editAttendanceConfirmMessage:
      'Changes to the attendance timeframe will reset late time calculations for students. Students marked as late will remain marked as late.',
    deleteAttendance: 'Delete attendance',
    updateDateTimeError: 'Could not update date and time. Please try again.',
    loadingPeriods: 'Loading periods…',
    periodsUnavailable: 'Periods unavailable',
    noPeriods: 'No periods',
    selectPeriod: 'Select period',
    addNotePlaceholder: 'Add note...',
    moreOptionsNoneAria: 'More options (none available)',
    timeSelectionModeAria: 'Time selection mode',
    periodAria: 'Period',
    timeRangeReadOnlyAria: 'Time range (read only)',
    present: 'Present',
    late: 'Late',
    excused: 'Excused',
    absent: 'Absent',
    entryTime: 'Entry Time',
    minutesLate: 'Minutes Late',
    entryTimePlaceholder: '10:15 AM',
    minutesLatePlaceholder: '15',
    entryTimeOutsideWindow: 'Entry time must be within the attendance window ({{window}}).',
    minutesLateInvalid: 'Minutes late must be a positive number.',
    futureDateNotAllowed: 'Attendance cannot be set to a future date.',
    statPresent: 'Present ({{count}})',
    statLate: 'Late ({{count}})',
    statAbsent: 'Absent ({{count}})',
    statExcused: 'Excused ({{count}})',
    statTotalPresence: 'Total presence ({{count}})',
    statTotalAbsence: 'Total absence ({{count}})',
    actionsForAttendanceAria: 'Actions for attendance on {{date}}',
    attendanceDateAria: 'Attendance date',
    startTimeAria: 'Start time',
    endTimeAria: 'End time',
    selectPeriodLabel: 'Select Period',
    loadingAttendance: 'Loading attendance…',
    deleteAttendanceConfirmTitle: 'Delete attendance?',
    deleteAttendanceConfirmAria: 'Delete attendance',
    deleteAttendanceMessage:
      'This will permanently remove the attendance record for {{date}}{{periodSuffix}}.',
    deleteAttendancePeriodSuffix: ' ({{period}})',
    attendanceHistory: 'Attendance History',
    activeAttendance: 'Active Attendance',
    loadAttendanceError: 'Failed to load attendance. Please try again.',
    confirmDeleteAttendanceAria: 'Confirm delete attendance',
    deleteAttendanceSessionMessage:
      "This will permanently remove the attendance session{{dateSuffix}}{{timeSuffix}}. This action can't be undone.",
    deleteAttendanceDateSuffix: ' for {{date}}',
    deleteAttendanceTimeSuffix: ' ({{time}})',
    report: 'Report',
    generatingReport: 'Generating…',
    viewReport: 'View Report',
    emailReport: 'Email Report',
    emailingReport: 'Sending…',
    reportEmailed: 'Report Emailed',
    reportError: 'Failed to generate report. Please try again.',
    reportDialogTitle: 'Attendance Report',
    reportDialogAria: 'Attendance report options',
    reportDialogMessage: 'How would you like to view your attendance report?',
    emailReportConfirmTitle: 'Email Attendance Report',
    emailReportConfirmMessage:
      'Your full attendance report will be sent to your email address as an attachment.',
    myAttendance: 'My Attendance',
    acceptAttendance: 'Accept Attendance',
    acceptAttendanceTitle: 'Accept Attendance',
    activeAttendanceHint: 'Your teacher is taking attendance now',
    markedPresent: 'You were marked as Present',
    markedLate: 'You were marked as Late',
    markedLateMinutes: 'You were marked as Late ({{count}} Minutes)',
    markedAbsent: 'You were marked as Absent',
    markedExcused: 'You were marked as Excused',
    loadingStudentAttendance: 'Loading your attendance…',
    loadStudentAttendanceError: 'Could not load your attendance',
    loadStudentAttendanceErrorHint: 'Please try again in a moment.',
    studentAttendanceEmptyLinkedTitle: 'No attendance yet',
    studentAttendanceEmptyLinkedDescription:
      'When your teacher takes attendance you will see your status here.',
    studentAttendanceEmptyUnlinkedTitle: 'Account not linked',
    studentAttendanceEmptyUnlinkedDescription:
      'To view your attendance, grades, and accept auto-attendance, ask the class owner to link your account with your name on the roster.',
    scanQrCode: 'Scan the QR code',
    enterAttendanceCode: 'Or enter the 6-digit code',
    enterAttendanceCodeAria: 'Enter 6-digit attendance code',
    orEnterCode: 'or',
    codeDigitsOnly: 'Only numbers are allowed',
    validatingCode: 'Validating code…',
    validateCodeError: 'Invalid code. Please try again.',
    acceptSuccessTitle: 'Attendance accepted',
    acceptSuccessMessage: 'You were marked as Present',
    qrScannerUnsupported: 'QR scanning is not supported in this browser. Enter the code manually.',
    qrScannerDenied: 'Camera access is required to scan the QR code.',
    qrScannerError: 'Could not start the camera. Enter the code manually.',
    qrScannerRetry: 'Try again',
  },
  resources: {
    title: 'Class Resources',
    uploadResource: 'Upload Resource',
    addNewSection: 'Add new section',
    loading: 'Loading resources…',
    filterByTypeAria: 'Filter resources by file type',
    engagementDetails: 'Engagement Details',
    totalOpens: 'Total Opens',
    uniqueStudents: 'Unique Students',
    avgViewed: 'Avg Viewed',
    lastOpened: 'Last opened: {{date}}',
    opens: 'Opens',
    viewed: 'Viewed',
    showStats: 'Show stats',
    sort: 'Sort',
    moveToAnotherClass: 'Move to another class',
    delete: 'Delete',
    addResource: 'Add resource',
    sectionNamePlaceholder: 'Section name',
    saveSectionAria: 'Save section',
    cancelSectionAria: 'Cancel',
    renameSection: 'Rename',
    moveSectionUp: 'Move up',
    moveSectionDown: 'Move down',
    deleteSection: 'Delete section',
    sortFiles: 'Sort files',
    confirmDeleteSection: 'Delete section?',
    confirmDeleteSectionMessage:
      'This will permanently delete "{{name}}" and all its resources. This action cannot be undone.',
    confirmDeleteResource: 'Delete resource?',
    confirmDeleteResourceMessage:
      'This will permanently delete "{{name}}". This action cannot be undone.',
    moveResourceTitle: 'Move to section',
    moveResourceLabel: 'Select a section to move "{{name}}" to:',
    moveUp: 'Move up',
    moveDown: 'Move down',
    moveToSection: 'Move to section…',
    deleteResource: 'Delete',
    uploadTitle: 'Upload Resource',
    uploadDropZone: 'Drag and drop your file here, or',
    uploadBrowse: 'browse',
    uploadSupportedTypes: 'PDF, Word, Excel, PowerPoint, Video',
    uploadSectionLabel: 'Add to section',
    uploadButton: 'Upload',
    uploading: 'Uploading…',
    uploadSuccess: 'File uploaded successfully',
    uploadError: 'Upload failed. Please try again.',
    selectFile: 'Select a file',
    noSections: 'No sections yet',
    emptySection: 'No files in this section',
  },
  progress: {
    reportTemplates: 'Report Templates',
    loadingTemplates: 'Loading report templates…',
    loadTemplatesError: 'Failed to load report templates. Please try again.',
    noTemplates: 'No report templates yet.',
    selectStudent: 'Select Student',
    backToReportsAria: 'Back to reports',
    backToTemplatesAria: 'Back to templates',
    backToStudentListAria: 'Back to student list',
    backToReportAria: 'Back to report',
    previousStudentAria: 'Previous student',
    nextStudentAria: 'Next student',
    reportActionsAria: 'Report actions',
    reportActionsFor: 'Actions for {{label}}',
    deleteReport: 'Delete report',
    enterTextPlaceholder: 'Enter text...',
    enterNumberPlaceholder: 'Enter number...',
    addNotePlaceholder: 'Add note...',
    submitted: 'Submitted',
    incomplete: 'Incomplete',
    copyToAll: 'Copy to all',
    loadingStudents: 'Loading students…',
    loadingReports: 'Loading reports…',
    loadStudentsError: 'Failed to load students. Please try again.',
    noStudentsInReport: 'No students in this report.',
    studentsIncluded: '{{included}}/{{total}} students included',
    submitNewReport: 'Submit a new report',
    submissionPeriod: 'Submission period',
    loadReportsError: 'Failed to load reports. Please try again.',
    noReportsSubmitted: 'No reports submitted yet.',
    loadingResponse: 'Loading response…',
    loadResponseError: 'Failed to load response. Please try again.',
    noResponseAvailable: 'No response available.',
  },
  questionResponses: {
    findAndReview: 'Find & review',
    recipient: 'Recipient',
    filterByStatusAria: 'Filter responses by status',
    viewingOneRecipient: 'Viewing one recipient',
    reviewStatus: 'Review status',
    recipientFilterHint:
      'Review status filters apply when browsing all recipients. Each person has one response — open them by name above.',
    viewAll: 'View all',
    searchRecipientsAria: 'Search recipients',
    searchRecipientsPlaceholder: 'Search {{count}} recipients…',
    noResponsesSubmitted: 'No responses submitted yet.',
    recipientSearchHint:
      'Search by name to open a single response. Use review status below to browse by progress across everyone.',
    needsReview: 'Needs review',
    graded: 'Graded',
    feedbackProvided: 'Feedback provided',
    gradedFeedback: 'Graded · Feedback',
    rejected: 'Rejected',
    filterAll: 'All',
  },
  globalCalendar: {
    previousMonthAria: 'Previous month',
    nextMonthAria: 'Next month',
    selectMonthAria: 'Select month',
    selectYearAria: 'Select year',
    selectDatePrompt: 'Select a date',
    noEventsScheduled: 'No events scheduled',
    allClasses: 'All Classes',
  },
  push: {
    promptRegionAria: 'Enable notifications',
    promptTitle: 'Stay in the loop',
    promptBody:
      'Turn on browser notifications to get class updates and messages the moment they happen.',
    promptEnable: 'Enable notifications',
    promptDismiss: 'Not now',
    promptError:
      'Notifications could not be enabled. Check browser site permissions, then try again.',
    toastRegionAria: 'Notifications',
    toastDismissAria: 'Dismiss notification',
    gateEnabled: 'Notifications enabled',
    gateBlockedTitle: 'Notifications are blocked',
    gateBlockedBody:
      "MyU needs permission to send notifications before you can sign in. Click the lock icon in your browser's address bar and set Notifications to Allow, then reload this page.",
    gateRequiredTitle: 'Notifications required',
    gateRequiredBody: 'Enable browser notifications to continue.',
    gateRequesting: 'Requesting…',
    gateEnable: 'Enable notifications',
    gateContinueAria: 'Enable notifications to continue',
  },
  tutorPackages: {
    title: 'Packages',
    loading: 'Loading packages…',
    loadError: 'Unable to load packages right now.',
    emptyTitle: 'No packages yet',
    emptyDescription: 'This tutor has not published any paid class packages.',
    priceValidity: '{{price}} · {{days}} days',
    subscribed: 'Subscribed',
    subscribe: 'Subscribe',
    selectPackage: 'Select',
    subscribing: 'Subscribing…',
    subscribeModalTitle: 'Subscribe to package',
    subscribeModalCancel: 'Cancel',
    couponLabel: 'Promo code',
    couponPlaceholder: 'Enter promo code',
    couponApply: 'Apply',
    couponApplying: 'Applying…',
    couponApplied: 'Promo {{code}} applied (−{{value}})',
    couponRequired: 'Enter a promo code to apply.',
    couponInvalid: 'Invalid promo code.',
    applyPromo: 'Have a promo code?',
    checkoutError: 'Unable to start checkout. Please try again.',
    checkoutOpened: 'Payment page opened in a new tab. Complete payment to join the classes.',
    freeSubscribed: 'Subscription completed. Your classes should appear shortly.',
    confirmationLoading: 'Loading order summary…',
    confirmationErrorTitle: 'Order not found',
    confirmationErrorDescription:
      'We could not find this payment reference. If you just paid, wait a moment and refresh.',
    confirmationSuccessTitle: 'Payment successful',
    confirmationSuccessDescription:
      'Your tutor package purchase is complete. Mapped classes are unlocked automatically.',
    confirmationPendingTitle: 'Payment status',
    confirmationPendingDescription: 'Current status: {{status}}.',
    packageLabel: 'Package',
    amountLabel: 'Amount',
    validityLabel: 'Validity',
    validityDays: '{{days}} days',
    referenceLabel: 'Reference',
    viewTutorProfile: 'View tutor profile',
    backToFeed: 'Back to feed',
    exploreTitle: 'Tutors',
    recommendedTitle: 'Recommended for you',
    subscriptionPageEyebrow: 'Tutor packages',
    subscriptionPageTitle: '@{{username}}',
    subscriptionPageDescription: 'Subscribe to paid class packages from this tutor.',
    subscriptionPageMissingUsername: 'No tutor username was provided.',
    backToProfile: 'Back to profile',
    directoryTitle: 'Tutors',
    directoryDescription: 'Browse tutors and open their subscription packages.',
    directoryLoadError: 'Unable to load tutors right now.',
    directoryEmptyTitle: 'No tutors yet',
    directoryEmptyDescription: 'Tutors will appear here when accounts are available.',
    viewPackages: 'Packages',
    loadMoreTutors: 'Load more',
  },
  admissions: {
    loading: 'Loading…',
    formUnavailable: 'This application form is unavailable.',
    subtitle: 'Complete each step to submit your application.',
    progress: 'Application progress',
    registrationFee: 'Registration fee',
    requiredFields: 'Please complete all required fields.',
    select: 'Select…',
    grade: 'Grade',
    enrollmentYears: 'Enrollment years',
    reviewTitle: 'Review your application',
    applicantName: 'Applicant name',
    paymentNotice: 'You will be asked to complete the registration fee payment after submitting.',
    documentsNotice: 'You can upload the required documents after submitting.',
    back: 'Back',
    next: 'Next',
    submitting: 'Submitting…',
    submit: 'Submit application',
    submitAndPay: 'Submit and pay',
    submitSuccess: 'Your application was submitted successfully.',
    paymentSuccess: 'Payment completed successfully.',
    paymentFailed: 'Payment was not completed.',
    paymentStartFailed: 'Unable to start payment. Please try again.',
    uploadDocuments: 'Upload documents',
    backToForm: 'Back to application',
    documentsUnavailable: 'These documents are unavailable.',
    documentProgress: '{{uploaded}} of {{total}} required documents uploaded',
    documentsComplete: 'All required documents have been uploaded.',
    viewDocument: 'View uploaded document',
    notUploaded: 'Not uploaded yet',
    uploading: 'Uploading…',
    chooseFile: 'Choose file',
    finish: 'Finish',
    steps: {
      basic: 'Student',
      grade: 'Grade',
      contact: 'Contact',
      medical: 'Medical',
      custom: 'Additional',
      review: 'Review',
    },
    fields: {
      first_name: 'First name',
      last_name: 'Last name',
      arabic_name: 'Arabic name',
      government_id: 'Government ID',
      dob: 'Date of birth',
      gender: 'Gender',
      nationality: 'Nationality',
      religion: 'Religion',
      father_full_name: "Father's full name",
      father_civil_id: "Father's civil ID",
      father_nationality: "Father's nationality",
      mother_full_name: "Mother's full name",
      mother_civil_id: "Mother's civil ID",
      mother_nationality: "Mother's nationality",
      other_note: 'Other notes',
      father_email: "Father's email",
      father_mobile: "Father's mobile",
      mother_email: "Mother's email",
      mother_mobile: "Mother's mobile",
      contact_person: 'Contact person',
      contact_person_relation: 'Relationship',
      contact_number: 'Contact number',
      contact_email: 'Contact email',
      home_address: 'Home address',
      medical_condition: 'Medical condition',
      learning_disabilities: 'Learning disabilities',
      food_allergies: 'Food allergies',
      special_needs: 'Special needs',
    },
  },
} as const;

export type EnTranslations = typeof en;
